import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './index.css';
import './dividor.css';
import App from './App';
import Navbar from './Navbar';
import Landing from './Landing.js';
import Why from './why';
import Contact from './Contact.js';
import InternalApp from './internal/InternalApp';
import reportWebVitals from './reportWebVitals';

function PublicSite() {
  return (
    <>
      <Landing />
      <App />
      <Why />
      <Contact />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Helmet>
      <meta charSet="utf-8" name="Pinaki Infotech" content="width=device-width, initial-scale=1.0" />
      <title>Pinaki Infotech</title>
    </Helmet>
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<PublicSite />} />
        <Route path="/internal/*" element={<InternalApp />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
